import { getIsPublishedAssignment } from "@/assignments/utils/assignmentUtils";
import globalToasterRef from "@/base/globalToasterRef";
import { Assignment } from "@/types/models/Assignment.interface";
import { AssignmentToast } from "@/view/AssignActionsContainer/AssignActionsContainer.interface";

interface HandleSaveConfirmation {
  isDraft: boolean;
  currentAssignment: Assignment;
  saveSuccessToastProps: AssignmentToast;
  setShareModalActive: (bool: boolean) => void;
}

export const handleSaveConfirmation = ({
  isDraft,
  currentAssignment,
  saveSuccessToastProps,
  setShareModalActive,
}: HandleSaveConfirmation) => {
  const wasPreviouslyPublished = getIsPublishedAssignment(currentAssignment);

  if (!isDraft && !wasPreviouslyPublished) {
    setShareModalActive(true);
  } else {
    globalToasterRef.current.displayToast(saveSuccessToastProps);
  }
};

export default handleSaveConfirmation;
